export function removeEntityOnUploadFailure(entity) {
  const parent = entity?.parentNode;
  if (!parent || typeof parent.removeChild !== "function") {
    return false;
  }

  parent.removeChild(entity);
  return true;
}
